import React from 'react';
import { Dumbbell, Zap } from 'lucide-react';

export default function WorkoutPeriodSummaryCard({
  title,
  exerciseCount,
  caloriesLabel,
  isSequenceMode,
  onEditSequence,
  onSaveSequence,
  onCancelSequence,
}) {
  return (
    <div className="flex-shrink-0 self-center">
      <div className="bg-gradient-to-br from-orange-primary to-orange-600 rounded-xl shadow-md p-4 w-32 min-h-40 flex flex-col items-center justify-center text-white">
        <Dumbbell className="w-6 h-6 mb-2" />
        <h3 className="text-sm font-bold text-center leading-tight mb-1">{title}</h3>
        <span className="text-xs opacity-90">
          {exerciseCount} exercise{exerciseCount !== 1 ? 's' : ''}
        </span>
        {caloriesLabel && (
          <span className="text-xs mt-1 font-medium opacity-95 flex items-center gap-0.5">
            <Zap className="w-3 h-3" />
            {caloriesLabel}
          </span>
        )}
        <div className="mt-3 w-full">
          {!isSequenceMode ? (
            <button
              type="button"
              onClick={onEditSequence}
              className="w-full text-[10px] font-medium py-1 rounded bg-white/20 hover:bg-white/30 transition-colors"
            >
              Reorder
            </button>
          ) : (
            <div className="flex flex-col gap-1">
              <button
                type="button"
                onClick={onSaveSequence}
                className="w-full text-[10px] font-medium py-1 rounded bg-white text-orange-600"
              >
                Save order
              </button>
              <button
                type="button"
                onClick={onCancelSequence}
                className="w-full text-[10px] font-medium py-1 rounded bg-white/20 hover:bg-white/30"
              >
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
